<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>{{isCreating?'Crea una caja':'Edita una caja'}}</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm form-group">
							<label for="name" class="form-label">Alias<span
								class="required">*</span></label>
							<input type="text" [(ngModel)]="newCashier.name" placeholder="Ingresa el código" name="name"
								id="name" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="manager" class="form-label">Encargado</label>
							<select name="manager" id="manager" [(ngModel)]="newCashier.manager" class="form-select">
								<option *ngFor="let user of users" value="{{user.id}}">{{user.email}}</option>
							</select>
						</div>
						<div class="col-sm form-group">
							<label for="description" class="form-label">Descripción </label>
							<input type="text" [(ngModel)]="newCashier.description"
								placeholder="Ingresa una descripción" name="description" id="description"
								class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col-sm form-group">
							<label for="amount" class="form-label">Balance Quetzales</label>
							<input type="number" [disabled]="!isCreating" [(ngModel)]="newCashier.amount"
								placeholder="0.00" name="amount" id="amount" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="minimum" class="form-label">Balance Mínimo de Quetzales</label>
							<input type="number" [(ngModel)]="newCashier.minimum" placeholder="0.00" name="minimum"
								id="minimum" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="maximum" class="form-label">Balance Máximo de Quetzales</label>
							<input type="number" [(ngModel)]="newCashier.maximum" placeholder="0.00" name="maximum"
								id="maximum" class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col-sm form-group">
							<label for="amountForeign" class="form-label">Balance Dolares</label>
							<input type="number" [disabled]="!isCreating" [(ngModel)]="newCashier.amountForeign"
								placeholder="0.00" name="amountForeign" id="amountForeign" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="minimumForeign" class="form-label">Balance Mínimo de Dolares</label>
							<input type="number" [(ngModel)]="newCashier.minimumForeign" placeholder="0.00"
								name="minimumForeign" id="minimumForeign" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="maximumForeign" class="form-label">Balance Máximo de Dolares</label>
							<input type="number" [(ngModel)]="newCashier.maximumForeign" placeholder="0.00"
								name="maximumForeign" id="maximumForeign" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="warehouse" class="form-label">Bodega</label>
							<select name="warehouse" id="warehouse" [(ngModel)]="newCashier.warehouse" class="form-select">
								<option value="null">Sin bodega asignada</option>
								<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">{{warehouse.name}}</option>
							</select>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-sm noAlert">
							<span [class.active-noAlert]="newCashier.noAlertOnSells"
								(click)="newCashier.noAlertOnSells = !newCashier.noAlertOnSells">
								<i class="fa fa-bell-slash"></i>No sugerir cortes
							</span>
						</div>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para {{isCreating?'guardar':'guardar los cambios de'}} la caja</p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="!newCashier.name || loading"
						(click)="createCashier()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>{{isCreating?'GUARDAR':'GUARDAR CAMBIOS'}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>